import React, { Component } from 'react'
import {
  extendParentClass,
  extendBaseClass,
  extend,
} from '../../../utils/classes'
import Item from './Item'

export class Stats extends Component {
  baseClass = extendParentClass.bind(this)('stats')

  extend = extendBaseClass.bind(this)

  contentClass = this.extend('content')

  extendContentClass = (childClass) => extend(this.contentClass, childClass)

  statistics = [
    {
      statistic: 45,
      symbol: 'k',
      name: 'Users',
    },
    {
      statistic: 90,
      symbol: '+',
      name: 'Countries',
    },
    {
      statistic: 10,
      symbol: '+',
      name: 'Integrations',
    },
    {
      statistic: 95,
      symbol: '%',
      name: 'Satisfaction',
    },
  ]

  renderStatistics = () =>
    this.statistics.map((statisticData, index) => (
      <Item {...statisticData} key={index} parentClass={this.contentClass} />
    ))

  render() {
    return (
      <div className={this.baseClass}>
        <div className={this.contentClass}>{this.renderStatistics()}</div>
      </div>
    )
  }
}

export default Stats
